import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

const days = ['월', '화', '수', '목', '금', '토', '일'];

const CustomBarChart = ({ data = [] }) => {
  // data: [1, 1, 0, 1, 1, 1, 0] 형태
  const chartData = days.map((day, i) => ({
    name: day,
    학습: data[i] || 0,
  }));

  return (
    <ResponsiveContainer width="100%" height={120}>
      <BarChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="name" />
        <YAxis allowDecimals={false} domain={[0, 1]} hide />
        <Tooltip />
        <Bar dataKey="학습" fill="#1976d2" radius={[6, 6, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CustomBarChart;
